// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"oM-z","carouselContainer":"pM-z"};